/* PilotstoriesArt calendar page (sections/psa-calendar-product.liquid): page strip, previous / next, swipe on the page,
   arrow keys, the lightbox picture and the sticky add-to-cart bar below 960 px (as on the print page, assets/psa-product.js). */
(function () {
  'use strict';
  var WIDTHS = [600, 900, 1200, 1800];

  // Shopify image URLs carry "width=…"; the other sizes differ only there
  function srcset(url) {
    if (!/[?&]width=\d+/.test(url)) return '';
    return WIDTHS.map(function (w) { return url.replace(/([?&])width=\d+/, '$1width=' + w) + ' ' + w + 'w'; }).join(', ');
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function setImg(img, url, alt) {
    if (!img) return;
    var s = srcset(url);
    if (s) img.setAttribute('srcset', s); else img.removeAttribute('srcset');
    img.src = url;
    img.alt = alt;
  }

  function Calendar(root) {
    this.root = root;
    this.thumbs = Array.prototype.slice.call(root.querySelectorAll('.psa-cal-thumb'));
    this.stage = root.querySelector('.psa-cal-stage-img');
    this.lb = root.querySelector('.psa-cal-lb-img');
    this.caption = root.querySelector('[data-psa-cal-caption]');
    this.counter = root.querySelector('[data-psa-cal-count]');
    this.i = 0;
    this.bind();
    this.observeAtc();
  }

  Calendar.prototype.show = function (i, focus) {
    var n = this.thumbs.length;
    if (!n) return;
    i = (i + n) % n;
    this.i = i;
    var t = this.thumbs[i], url = t.getAttribute('data-src'), alt = t.getAttribute('data-alt');
    setImg(this.stage, url, alt);
    setImg(this.lb, url, alt);
    if (this.caption) this.caption.textContent = alt;
    if (this.counter) this.counter.textContent = pad(i + 1) + ' / ' + pad(n);
    this.thumbs.forEach(function (b, k) { b.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    if (focus) t.focus();
    // Load the neighbours in the background, so paging is instant
    var sizes = this.stage ? this.stage.getAttribute('sizes') : '';
    [i + 1, i - 1].forEach(function (k) {
      var u = this.thumbs[(k + n) % n].getAttribute('data-src'), pre = new Image();
      if (sizes) pre.sizes = sizes;
      var s = srcset(u); if (s) pre.srcset = s;
      pre.src = u;
    }, this);
  };

  Calendar.prototype.bind = function () {
    var self = this, root = this.root;
    root.addEventListener('click', function (e) {
      var t = e.target.closest('.psa-cal-thumb');
      if (t && root.contains(t)) { self.show(self.thumbs.indexOf(t)); return; }
      if (e.target.closest('[data-psa-cal-prev]')) { self.show(self.i - 1); return; }
      if (e.target.closest('[data-psa-cal-next]')) { self.show(self.i + 1); return; }
      if (e.target.closest('[data-psa-bar-add]')) {
        var f = document.getElementById(root.getAttribute('data-form-id'));
        if (f) { if (f.requestSubmit) f.requestSubmit(); else f.submit(); }
      }
    });
    // Arrow keys: in the page strip, and while the lightbox is open
    root.addEventListener('keydown', function (e) {
      if (!e.target.closest || !e.target.closest('.psa-cal-strip')) return;
      var d = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
      if (!d) return;
      e.preventDefault();
      self.show(self.i + d, true);
    });
    document.addEventListener('keydown', function (e) {
      var dlg = self.lb && self.lb.closest('[data-psa-dialog]');
      if (!dlg || dlg.hidden) return;
      if (e.key === 'ArrowRight') self.show(self.i + 1);
      else if (e.key === 'ArrowLeft') self.show(self.i - 1);
    });
    // Swipe left / right on the page
    var stage = root.querySelector('[data-psa-cal-stage]'), x0 = null, y0 = null;
    if (stage) {
      stage.addEventListener('touchstart', function (e) { var p = e.changedTouches[0]; x0 = p.clientX; y0 = p.clientY; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (x0 == null) return;
        var p = e.changedTouches[0], dx = p.clientX - x0, dy = p.clientY - y0;
        x0 = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) self.show(self.i + (dx < 0 ? 1 : -1));
      }, { passive: true });
    }
  };

  // Shown once the form's own button has scrolled out above the screen (checked on scroll, so a jump to the top hides it too)
  Calendar.prototype.observeAtc = function () {
    var atc = this.root.querySelector('[data-psa-atc]'), bar = this.root.querySelector('[data-psa-atc-bar]');
    if (!atc || !bar) return;
    var mq = window.matchMedia('(max-width: 959px)'), raf = 0;
    var update = function () { raf = 0; bar.hidden = !(mq.matches && atc.getBoundingClientRect().bottom < 0); };
    window.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(update); }, { passive: true });
    if (mq.addEventListener) mq.addEventListener('change', update);
    update();
  };

  function init(scope) {
    (scope || document).querySelectorAll('[data-psa-calendar]').forEach(function (r) { if (!r._psaCal) r._psaCal = new Calendar(r); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
